module.exports = __webpack_public_path__ + "static/media/store_x4.8b0e51d5.svg";